import { render, staticRenderFns } from "./HowToDonate.vue?vue&type=template&id=3ae8b7b8&"
import script from "./HowToDonate.vue?vue&type=script&lang=js&"
export * from "./HowToDonate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports